<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap pb-5>
                        <v-flex xs12 pb-5>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex xs12>
                            <h1>Настройки компаний Е-Гарант</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-card>
                                <v-toolbar flat>
                                    <v-toolbar-title>Компании Е-гарант</v-toolbar-title>
                                </v-toolbar>
                                <v-divider style="border-color:black"></v-divider>
                                <v-list v-if="companiesList.length > 0">
                                    <template v-for="(company,index) in companiesList">
                                        <v-divider
                                            v-if="index > 0"
                                        ></v-divider>
                                        <v-list-tile
                                            :key="company.id"
                                            @click=""
                                        >
                                            <v-list-tile-content
                                                @click="editCompany(company.id)"
                                            >
                                                <v-list-tile-title v-text="company.name"></v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action v-if="company.integrated">
                                                <v-icon :color="company.active ? '#00ba57' : 'gray'">sync_alt</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                                <h4 v-if="companiesList.length === 0" class="centered pt-5">
                                    Не найдено ни одной компании
                                </h4>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: "EgarantCompaniesList",
    props: ['companies'],
    data: () => ({
        companiesList: []
    }),
    created() {
        if (this.companies) {
            this.companiesList = JSON.parse(window.atob(this.companies));
        }
    },
    methods: {
        editCompany(id) {
            if (id) {
                window.location.href = '/egarant-companies/' + id;
            } else {
                console.log('Company id was not specified')
            }
        }
    }
}
</script>

<style scoped>
    /deep/ h1 {
        font-size: 48px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3, h4 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    /deep/ h4 {
        font-size: 16px;
    }

    .centered {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/egarant-companies/EgarantCompaniesList.vue